import { Link, TextField, useCreatePath } from "react-admin"; //ra-core
import { Debug } from "./debug";
import { Visibility } from "@mui/icons-material";
import { RecordTooltip } from "./recordTooltip";

export const MyLinkField = ({
  resource,
  record,
  source = "name",
  linkType: type = "show",
  ...rest
}) => {
  const createPath = useCreatePath();
  const id = record["id"];
  const path = createPath({ resource, id, type });
  return (
    <Link className="MyLinkField" to={path} {...rest}>
      <RecordTooltip record={record}>
        <TextField record={record} source={source} />
        <Visibility />
        {source != "id" && <Debug> (#{id})</Debug>}
      </RecordTooltip>
    </Link>
  );
};
